import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['day', 'button', 'scrollContainer', 'leftIndicator', 'rightIndicator']
  static values = { current: { type: String, default: 'monday' } }

  connect() {
    this.showDay(this.currentValue)

    // Bind method references for event listeners
    this.boundUpdateScrollIndicators = this.updateScrollIndicators.bind(this)

    // Listen for scroll events
    if (this.hasScrollContainerTarget) {
      this.scrollContainerTarget.addEventListener('scroll', this.boundUpdateScrollIndicators)

      // Update indicators after a short delay to ensure layout is complete
      setTimeout(() => {
        this.updateScrollIndicators()
      }, 100)

      // Also update on window resize
      window.addEventListener('resize', this.boundUpdateScrollIndicators)
    }
  }

  disconnect() {
    // Clean up event listeners
    if (this.hasScrollContainerTarget) {
      this.scrollContainerTarget.removeEventListener('scroll', this.boundUpdateScrollIndicators)
      window.removeEventListener('resize', this.boundUpdateScrollIndicators)
    }
  }

  selectDay(event) {
    const day = event.currentTarget.dataset.day
    this.showDay(day)
  }

  showDay(day) {
    this.currentValue = day

    // Update button states
    this.buttonTargets.forEach(button => {
      if (button.dataset.day === day) {
        button.classList.add('bg-blue-600', 'text-white')
        button.classList.remove('bg-gray-200', 'dark:bg-gray-700', 'text-gray-700', 'dark:text-gray-300')
      } else {
        button.classList.remove('bg-blue-600', 'text-white')
        button.classList.add('bg-gray-200', 'dark:bg-gray-700', 'text-gray-700', 'dark:text-gray-300')
      }
    })

    // Update day visibility
    this.dayTargets.forEach(dayElement => {
      if (dayElement.dataset.day === day) {
        dayElement.classList.remove('hidden')
      } else {
        dayElement.classList.add('hidden')
      }
    })
  }

  updateScrollIndicators() {
    if (!this.hasScrollContainerTarget) return

    const container = this.scrollContainerTarget
    const scrollLeft = container.scrollLeft
    const maxScroll = container.scrollWidth - container.clientWidth

    // Only show indicators if content is scrollable
    const isScrollable = maxScroll > 0

    if (!isScrollable) {
      // Hide both indicators if not scrollable
      if (this.hasLeftIndicatorTarget) {
        this.leftIndicatorTarget.classList.add('opacity-0')
        this.leftIndicatorTarget.classList.remove('opacity-100')
      }
      if (this.hasRightIndicatorTarget) {
        this.rightIndicatorTarget.classList.add('opacity-0')
        this.rightIndicatorTarget.classList.remove('opacity-100')
      }
      return
    }

    // Show/hide left indicator
    if (this.hasLeftIndicatorTarget) {
      if (scrollLeft > 5) {
        this.leftIndicatorTarget.classList.remove('opacity-0')
        this.leftIndicatorTarget.classList.add('opacity-100')
      } else {
        this.leftIndicatorTarget.classList.remove('opacity-100')
        this.leftIndicatorTarget.classList.add('opacity-0')
      }
    }

    // Show/hide right indicator
    if (this.hasRightIndicatorTarget) {
      if (scrollLeft < maxScroll - 5) {
        this.rightIndicatorTarget.classList.remove('opacity-0')
        this.rightIndicatorTarget.classList.add('opacity-100')
      } else {
        this.rightIndicatorTarget.classList.remove('opacity-100')
        this.rightIndicatorTarget.classList.add('opacity-0')
      }
    }
  }
}
